export enum GroupActionValidationStatus {
    Valid = "Valid",
    MapLoading = "MapLoading",
    InvalidSelectionAmount = "InvalidTypeSelectionAmount",
    InvalidPermissions = "InvalidPermissions",
    InvalidTypeSelection = "InvalidTypeSelectionType",
    InvalidNestedLevel = "InvalidNestedLevel",
    InvalidParent = "InvalidParent",
}

export enum UnlinkLayerValidationStatus {
    Valid = "Valid",
    MapLoading = "MapLoading",
    InvalidSelectionAmount = "InvalidTypeSelectionAmount",
    InvalidSelectionNonImport = "InvalidSelectionNonImport",
    InvalidTypeSelection = "InvalidTypeSelectionType",
    InvalidPermissions = "InvalidPermissions",
}

export enum CopyActionValidationStatus {
    Valid = "Valid",
    MapLoading = "MapLoading",
    InvalidSelectionAmount = "InvalidTypeSelectionAmount",
    InvalidTypeSelection = "InvalidTypeSelectionType",
    InvalidPermissions = "InvalidPermissions",
}

export enum DeleteActionValidationStatus {
    Valid = "Valid",
    MapLoading = "MapLoading",
    InvalidSelectionAmount = "InvalidTypeSelectionAmount",
    InvalidTypeSelection = "InvalidTypeSelectionType",
    InvalidPermissions = "InvalidPermissions",
}
